// import HighlightCard from "./HighlightCard";
// import styles from "./HighlightGrid.module.css";

// const HighlightGrid = ({ highlights = [] }) => {
//   if (!highlights.length) return null;

//   return (
//     <div className={styles.grid}>
//       {highlights.map((item) => (
//         <HighlightCard
//           key={item.id}
//           icon={item.icon}
//           value={item.value}
//           title={item.title}
//           description={item.description}
//         />
//       ))}
//     </div>
//   );
// };

// export default HighlightGrid;
import HighlightCard from "./HighlightCard";
import styles from "./HighlightGrid.module.css";

const HighlightGrid = ({ highlights = [] }) => {
  if (!highlights.length) return null;

  return (
    <div className={styles.grid}>
      {highlights.map((item) => (
        <HighlightCard
          key={item.id}
          icon={item.icon}
          value={item.value}
          title={item.title}
          description={item.description}
        />
      ))}
    </div>
  );
};

export default HighlightGrid;